import { Inject, Injectable } from '@angular/core';
import { IAppConfig } from './config/app-config.model';
import { APP_CONFIG } from './config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  logs: string[] = [];

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ) {
    (window as any)._xnLogs = this.logs;
  }

  log(str: any){
    // disable log on production
    if(this.config.production) return;
    if(!str) return;
    if(typeof str === 'string'){
      this.logs.push(str);
    }
    
    console.log(str);
  }
}
